import { CourseContent } from '@components/enrollments/courses/CourseContent'
import { CourseContentsProvider } from '@contexts/CourseContentsContext'
import { CourseProvider } from '@contexts/CourseContext'
import { EnrollmentProvider } from '@contexts/EnrollmentContext'
import { ExtraContentsProvider } from '@contexts/ExtraContentsContext'
import { LessonExtraContentsProvider } from '@contexts/LessonExtraContentsContext'
import { ModulesProvider } from '@contexts/ModulesContext'
import { CourseContextsResetProvider } from '@contexts/CourseContextsReset'
import { usePreviousRoute } from '@hooks/usePreviousRoute'
import { AppLayout } from '@layouts/AppLayout'
import { useCurrentLesson } from '@hooks/useCurrentLesson'
import { useEffect } from 'react'

export default function Course() {
  const { setCurrentLesson } = useCurrentLesson()
  const { backLabel } = usePreviousRoute()

  useEffect(() => {
    setCurrentLesson(null)
  }, [setCurrentLesson])

  return (
    <CourseProvider>
      <CourseContentsProvider>
        <ModulesProvider>
          <LessonExtraContentsProvider>
            <ExtraContentsProvider>
              <EnrollmentProvider>
                <CourseContextsResetProvider>
                  <AppLayout
                    backRoute={{
                      label: backLabel,
                    }}
                    hasPaddingBottom={false}
                    backgroundColor="$neutral-0"
                  >
                    <CourseContent />
                  </AppLayout>
                </CourseContextsResetProvider>
              </EnrollmentProvider>
            </ExtraContentsProvider>
          </LessonExtraContentsProvider>
        </ModulesProvider>
      </CourseContentsProvider>
    </CourseProvider>
  )
}
